var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDowninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.74 31.113"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 49",
    d: "M4.242 4.243L26.869 26.87"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 50",
    d: "M49.497 4.243L26.87 26.87"
  }))));
}
export default SvgCaretDowninline;